module.exports = __webpack_public_path__ + "img/4.0df604e3.jpg";